import { render, staticRenderFns } from "./ShortlinkCreate.vue?vue&type=template&id=56bbe01b&scoped=true&"
import script from "./ShortlinkCreate.vue?vue&type=script&lang=js&"
export * from "./ShortlinkCreate.vue?vue&type=script&lang=js&"
import style0 from "./ShortlinkCreate.vue?vue&type=style&index=0&id=56bbe01b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bbe01b",
  null
  
)

export default component.exports